var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgBoosterArrows = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 16,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.033 14.216 2.164 7.875l6.87-6.34A.873.873 0 1 0 7.848.25L.286 7.233a.873.873 0 0 0 0 1.283l7.563 6.982a.873.873 0 1 0 1.184-1.283",
  fill: "#757575",
  fillRule: "nonzero"
})));

export default SvgBoosterArrows;